module.exports = __webpack_public_path__ + "static/img/honour.64ba60e3.png";